<template>
  <div class="page">
    <div class="guest">
      <div class="guest-top">
        <div class="guestTitle">{{ props.data.titleCn }}</div>
        <div class="guestEn">{{ props.data.titleEn }}</div>
      </div>
      <div class="guest-bottom">
        <a-carousel arrows :dots="false" autoplay :autoplaySpeed="3000">
          <template #prevArrow>
            <div
              class="custom-slick-arrow custom-slick-arrow-left"
              style="left: 0; top: 172px; z-index: 1"
            >
              <img
                class="arrow"
                src="https://p1.ssl.qhimg.com/t110b9a9301bf0e594b9ca06ee7.png"
                alt=""
              />
            </div>
          </template>
          <template #nextArrow>
            <div class="custom-slick-arrow custom-slick-arrow-right" style="top: 172px; left: 97%">
              <img
                class="arrow"
                src="https://p3.ssl.qhimg.com/t110b9a9301ba3128d7da220256.png"
                alt=""
              />
            </div>
          </template>
          <div v-for="(item, index) in arr" :key="index" class="guestBox">
            <div class="guestBoxInfo">
              <div v-for="(child, index) in item" :key="index" class="guestBoxInfoItem">
                <img :src="child.avatar" alt="" class="guestBoxInfoItemImg" />
                <div class="guestBoxInfoItemName">{{ child.name }}</div>
                <div class="guestBoxInfoItemTitle van-multi-ellipsis--l3">
                  <a-tooltip>
                    <template #title>
                      <div class="tooltip-content">{{ child.title.join(',') }}</div>
                    </template>
                    {{ child.title.join(',') }}
                  </a-tooltip>
                </div>
              </div>
            </div>
          </div>
        </a-carousel>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getKeyGuest } from '@/api/2024/index'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

const arr = ref([])

onBeforeMount(async () => {
  await fetch()
})

const fetch = () => {
  getKeyGuest('ISC 荣誉主席,重磅嘉宾',2).then((res) => {
    let guests = res.data.data
    arr.value = chunkArray(guests, 4)
  })
}

const chunkArray = (array, chunkSize) => {
  const result = []
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize))
  }
  return result
}
</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  justify-content: center;
  .guest {
    width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 116px;
    .guest-top{
      display: flex;
      flex-direction: column;
      align-items: center;
      .guestTitle{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 36px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .guestEn{
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 16px;
      }
    }
    .guest-bottom{
      width: 100%;
      margin-top: 80px;
      .guestBox {
        // background-color: pink;
        .guestBoxInfo {
          display: flex;
          justify-content: space-between;
          .guestBoxInfoItem {
            width: 230px;
            .guestBoxInfoItemImg {
              width: 230px;
              height: 230px;
              border-radius: 50%;
              margin-bottom: 45px;
            }
            .guestBoxInfoItemName {
              font-family: Source Han Sans;
              font-size: 24px;
              font-weight: 500;
              line-height: 24px;
              letter-spacing: 0px;
              font-variation-settings: 'opsz' auto;
              /* Gray 中性/gray-9 */
              color: #242933;
              margin-bottom: 16px;
            }
            .guestBoxInfoItemTitle {
              padding: 0 10px;
              font-family: Source Han Sans;
              font-size: 16px;
              font-weight: normal;
              line-height: 24px;
              text-align: center;
              letter-spacing: 0px;
              font-variation-settings: 'opsz' auto;
              color: rgba(61, 61, 61, 0.698);
            }
          }
        }
      }
    }
  }
  .arrow {
    width: 48px;
  }
  :deep(.slick-slide) {
    text-align: center;
    padding: 0 116px 120px;
    //   background-color: pink;
  }
  
  .ant-carousel :deep(.slick-dots li button) {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #dfe1e6;
  }
  :deep(.slick-dots li.slick-active button) {
    background-color: #525966 !important;
  }
}

</style>
